import {
  Button,
  HeadingRegular,
  Modal,
  NavigationItem,
} from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { useThemedImageSource } from '@/domains/theme/useThemedImageSource';
import { StageProps } from '../../config/StrongerNudgeConfig';

interface CustomerPhoneBookingOptionProps {
  isConfirmationScreen?: boolean;
}

export const CustomerPhoneBookingOption = (
  props: CustomerPhoneBookingOptionProps & { onSubmit: StageProps['onSubmit'] },
) => {
  const { isConfirmationScreen, onSubmit } = props;
  const chatIcon = useThemedImageSource('spot-chat');
  const [isOpenCustomerPhoneBooking, setIsOpenCustomerPhoneBooking] =
    useState(false);

  const closeCustomerPhoneBooking = () => setIsOpenCustomerPhoneBooking(false);

  const openCustomerPhoneBooking = () => setIsOpenCustomerPhoneBooking(true);

  const handleCallPensionWise = async () => {
    await onSubmit({
      [isConfirmationScreen
        ? 'guidanceConfirmationOption'
        : 'guidanceAppointmentChoice']: 'Customer Phone Booking',
    });
    const phoneNumberHref = 'tel:0800100166';
    window.location.href = phoneNumberHref;
    closeCustomerPhoneBooking();
  };

  return (
    <>
      <NavigationItem
        handleClick={openCustomerPhoneBooking}
        title="Call to book an appointment"
        copy={
          isConfirmationScreen
            ? 'Call Pension Wise to arrange another appointment on 0800 100 166.'
            : 'Call Pension Wise to arrange your appointment on 0800 100 166.'
        }
        src={chatIcon}
        imageHeight="48px"
      />
      <Modal
        isOpen={isOpenCustomerPhoneBooking}
        handleClose={closeCustomerPhoneBooking}
        variant="bottom"
      >
        <div className="flex h-full flex-col justify-between">
          <HeadingRegular className="mb-28">
            You&apos;ll need to confirm you&apos;ve taken guidance before you
            can proceed.
          </HeadingRegular>
          <Button
            className="mb-20 mt-auto w-full md:w-auto"
            onClick={handleCallPensionWise}
          >
            OK
          </Button>
          <Button
            variant="secondary"
            className="mt-auto w-full md:w-auto"
            onClick={closeCustomerPhoneBooking}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
